import { useEffectWithDeepCompare } from '@gasbuddy/react-hooks';
import useAnalytics from './useAnalytics';

export default function useScreenView(screenName, attributes) {
  const analytics = useAnalytics();
  useEffectWithDeepCompare(() => {
    analytics.tagPageView({ name: screenName, attributes });
    analytics.tagEvent({
      name: 'Screen Viewed',
      attributes: {
        ...attributes,
        'Screen Name': screenName,
      },
    });
  }, [attributes, screenName]);
}
